
import * as Data from '@/../src-gen/data';
import {PaymentStoreGetters} from '@/../src-gen/store/payment-store-support';

export class PaymentStoreInit {
    public static initState(): Data.Payment.PaymentStore  { return new Data.Payment.PaymentStore(); }
}

export class PaymentStoreGettersCode implements PaymentStoreGetters {
 
  public paymentPlanDetails(state: Data.Payment.PaymentStore): Data.Payment.PaymentPlanDetails {
    return state.paymentPlanDetails;
  }
  public planDetails(state: Data.Payment.PaymentStore): Data.Payment.PlanDetails {
    return state.planDetails;
  }
  public msfSlabList(state: Data.Payment.PaymentStore): Data.Payment.MSFSlab[] {
    return state.msfSlabList;
  }
  

}
